import type { Job } from '../api/types'

/** Mirrors ai/worker.py's exact wording so a real job error always matches. */
const BUDGET_MESSAGE = 'daily budget reached'

/** The worker's http.py marks 400/401/403/404/422 fatal; the wording it
 *  raises always names the HTTP status or "could not be decrypted". */
const INVALID_KEY_PATTERNS = [
  /HTTP 401/i,
  /HTTP 403/i,
  /provider configuration error/i,
  /could not be decrypted/i,
]

export function isInvalidKeyError(error: string | null): boolean {
  return Boolean(error) && INVALID_KEY_PATTERNS.some((pattern) => pattern.test(error as string))
}

export function isBudgetError(error: string | null): boolean {
  return error === BUDGET_MESSAGE
}

export interface JobBanners {
  invalidKey: Job[]
  budget: Job[]
}

export function jobBanners(jobs: Job[]): JobBanners {
  return {
    invalidKey: jobs.filter((job) => isInvalidKeyError(job.error)),
    budget: jobs.filter((job) => isBudgetError(job.error)),
  }
}
